export const OFFSET_FOR_STICKY_HEADER = 90;
export const OFFSET_VERTICAL = -200; // 80 + 48 + 48 + 24
export const FAQ_DATA_TEST_ID = 'FAQ_main-content';
